import React from 'react'
import {Navigate} from 'react-router-dom'
import {eqxEvent} from '../../shared/classes/eqxEventBroker'
import generateContextProvider, {ContextProviderWrapperProps} from '../../shared/hooks/GenerateContextProvider'
import {useApiContext} from './AppApi'
import {useAuthContext} from './AppAuth'
import {useRouterContext} from './AppRouter'

/**
 * ensure the token is loaded before rendering the children
 * @param props
 * @returns
 */
const AppAuthTokenWrapper = (props: ContextProviderWrapperProps<string>) => {
    const TokenProvider = props.provider
    const auth = useAuthContext()
    const router = useRouterContext()
    const api = useApiContext()
    const token = auth.token

    api.token = token

    React.useEffect(() => {
        const eventId = api.events.on('response401', function (this: eqxEvent) {
            router.navigateToLogin()
        })
        return () => {
            api.events.removeEvent('response401', eventId)
        }
    }, [token])

    if (!token) {
        return <Navigate to={router.loginPath} />
    }

    return <TokenProvider value={token}>{props.children}</TokenProvider>
}

const {
    ContextProvider: AppAuthTokenProvider,
    useContext: useTokenContext,
    useContextOptional: useTokenContextOptional,
} = generateContextProvider<string>(undefined, AppAuthTokenWrapper)

export {AppAuthTokenProvider as default, useTokenContext, useTokenContextOptional}
